import type { CardSummary as Card } from "@hobbyshopify/backend-client";
import { cardTitle } from "../core/primitives/card-display";

/**
 * The one destructive-looking thing a merchant can do to a card, and what it
 * actually does. Not a delete: anything sold under this card keeps naming it.
 * The row's identity is never edited, so a wrong card is retired here and the
 * right one confirmed from a fresh scan.
 */
export function ArchiveCardModal({
  card,
  busy,
  error,
  onConfirm,
  onCancel,
}: {
  card: Card;
  busy?: boolean;
  error?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <div className="scrim items-end justify-center p-4 sm:items-center">
      <div className="modal relative w-full max-w-sm p-6">
        <h2 className="mb-1 text-base font-semibold text-white">Archive card</h2>
        <p className="mb-4 truncate text-sm text-muted">{cardTitle(card)}</p>

        <p className="text-sm text-muted">
          The card leaves your catalogue and stops being listed or quoted. Its online listing is archived and any open
          customer quotes lapse. Past sales keep pointing at it.
        </p>
        <p className="mt-2 text-xs text-faint">
          Scanning and confirming the same card again brings it back with its history.
        </p>

        {error && <p className="note note-danger mt-3 text-danger">{error}</p>}

        <div className="mt-6 flex gap-3">
          <button type="button" onClick={onCancel} disabled={busy} className="btn-secondary flex-1">
            Cancel
          </button>
          <button type="button" onClick={onConfirm} disabled={busy} className="btn-primary flex-1">
            {busy ? "Archiving…" : "Archive"}
          </button>
        </div>
      </div>
    </div>
  );
}
